/**
 * Factory for the pure config-passthrough Fill/transform effects — every
 * behavior kind EXCEPT `webhook` (which is bespoke, see webhook-lookup.ts).
 *
 * A behavior of these kinds stores its config as its own non-`kind` fields, so
 * compile spreads the step's config into the behavior and parse lifts it back
 * out unchanged. The field context comes from the FieldDefinition the behavior
 * attaches to, so `fieldName` is intentionally omitted from the parsed step —
 * the caller (which holds the field) re-supplies it.
 *
 * `defaultMoment` is provisional (P1a): parse has no stage slot to read, so it
 * stamps a fixed moment. P1b threads the real moment ↔ stage mapping.
 */
export function makeBehaviorPassthrough(kind, effectKey, defaultMoment) {
    const compile = (step) => ({ kind, ...step.config });
    const parse = (payload) => {
        if (!payload || typeof payload !== 'object')
            return null;
        if (payload.kind !== kind)
            return null;
        const { kind: _kind, ...config } = payload;
        void _kind;
        return { effectKey, moment: defaultMoment, scope: 'field', config };
    };
    return { compile, parse };
}
//# sourceMappingURL=behavior-passthrough.js.map